import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getFormCurrentValuesSelector } from '../../stateSelector';
import { RootState } from '../../types';
import useFormId from '../useFormId';

function useFormValues<T>(): T {
  const formId = useFormId();
  const selector = useCallback(
    (state: RootState<T>) => getFormCurrentValuesSelector(state, formId),
    [formId],
  );
  return useSelector(selector);
}

export default useFormValues;
